import { ClientsCloseOverviewView } from "@common/types/views/clientsCloseOverviewView";
import { NamedView } from "@common/types/views/views";
import { useMemo } from "react";
import { useDefaultClientsClosesView } from "./DefaultClientsClosesView";

export function useBuiltInClientsClosesViews(): Array<
    NamedView<ClientsCloseOverviewView>
> {
    const defaultView = useDefaultClientsClosesView();
    return useMemo(() => [defaultView], [defaultView]);
}
